
















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import axios from 'axios';
import router from '../../router';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { Constants } from '../../CommonUtils/fixed/Constants';
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ


@Component
export default class Logout extends ApiAccessBase {
  // axiosの共通設定
  protected axiosApi = axios.create();

  private created() {
    supervisingModule.allModuleReset();
  }

  private returnLogin() {
    if (supervisingModule.IS_ORDER_USER) {
      // ユーザが発注者の時
      router.push({name: ScreenName.ORDER_LOGIN});
    } else {
      // ユーザが受注者の時
      router.push({name: ScreenName.ACCEPTER_LOGIN});
    }
  }
}
